import { Card } from '@/design-system/ui/Card';
import { toPersianDigits } from '@/core/format/numbers';
import { useSEO } from '@/core/seo/useSEO';
import { CANCELLATION_RULES } from '@/core/config/content';
import { PageHeader } from '../components/PageHeader';

const CARGO_SECTIONS = [
  { title: '۱. پذیرش و ثبت مرسوله', body: 'با ثبت هر مرسوله در سامانه، فرستنده متعهد می‌شود اطلاعات مبدأ، مقصد و مشخصات گیرنده را به‌درستی وارد کرده باشد. صحت این اطلاعات مسئولیت فرستنده است و در صورت نادرست بودن، تأخیر یا برگشت مرسوله بر عهده شرکت نخواهد بود.' },
  { title: '۲. بسته‌بندی و اقلام ممنوعه', body: 'بسته‌بندی مناسب برای حفظ سلامت کالا در طول مسیر الزامی است. حمل اقلام ممنوعه شامل مواد قابل اشتعال، خطرناک، فاسدشدنی بدون بسته‌بندی مناسب و اقلام غیرقانونی به هیچ عنوان پذیرفته نمی‌شود.' },
  { title: '۳. زمان‌بندی و تحویل', body: 'بازه‌های زمانی اعلام‌شده برای تحویل، تخمینی و بر اساس شرایط عادی جاده و مسیر است (معمولاً بین ۱ تا ۳ ساعت در خطوط فعال). عوامل خارج از کنترل شرکت (شرایط جوی، ترافیک، تعطیلات رسمی) می‌تواند در زمان تحویل تأثیرگذار باشد.' },
  { title: '۴. مسئولیت و بیمه مرسوله', body: 'تمامی مرسولات ثبت‌شده در سامانه بلینو تا سقف ۲ میلیون تومان بدون دریافت هزینه مازاد تحت پوشش بیمه بلینو قرار دارند. در صورت بروز هرگونه حادثه یا آسیب، خسارت بر اساس ارزش واقعی و مستندات ثبت بار جبران خواهد شد.' },
  { title: '۵. مرجوعی و شکایات', body: 'در صورت وجود هرگونه اعتراض نسبت به نحوه حمل یا تحویل مرسوله، گیرنده یا فرستنده می‌توانند حداکثر تا ۷۲ ساعت پس از تحویل، از طریق صفحه «ثبت شکایت» موضوع را با ذکر کد رهگیری پیگیری کنند.' },
];

export default function TermsPage() {
  useSEO({
    title: 'قوانین، مقررات و شرایط استرداد',
    description: 'قوانین و مقررات خرید بلیط تاکسی بین‌شهری، شرایط کنسلی و استرداد وجه، و ضوابط ارسال و بیمه مرسولات در سامانه بلینو.',
    canonical: '/terms',
    keywords: 'قوانین بلینو, استرداد بلیط بلینو, جریمه کنسلی بلیط سواری, بیمه بار بلینو, شرایط حمل بار بین شهری',
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <PageHeader icon="doc" title="قوانین، مقررات و شرایط استرداد" subtitle="لطفاً پیش از رزرو سفر یا ثبت مرسوله، این شرایط را مطالعه فرمایید" />

      {/* Passenger Cancellation Rules */}
      <h2 className="mb-3 text-lg font-bold text-navy">قوانین کنسلی و استرداد بلیط سفر بین‌شهری</h2>
      <Card className="mb-8 divide-y divide-line-subtle p-5 sm:p-7">
        <ul className="space-y-3 text-sm leading-loose text-ink-2">
          {CANCELLATION_RULES.map((rule, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <span className="font-bold text-cta">•</span>
              <span>{rule}</span>
            </li>
          ))}
        </ul>
      </Card>

      {/* Cargo Rules */}
      <h2 className="mb-3 text-lg font-bold text-navy">ضوابط و شرایط ارسال و بیمه بار</h2>
      <Card className="divide-y divide-line-subtle">
        {CARGO_SECTIONS.map((s) => (
          <section key={s.title} className="p-5 sm:p-7">
            <h3 className="mb-2 font-bold text-navy">{s.title}</h3>
            <p className="text-sm leading-loose text-ink-2">{s.body}</p>
          </section>
        ))}
      </Card>
      <p className="mt-4 text-xs text-ink-2">آخرین به‌روزرسانی: {toPersianDigits(new Date().toLocaleDateString('fa-IR-u-nu-latn'))}</p>
    </div>
  );
}
